export const THEMES = {
  rose: {
    id: 'rose',
    name: 'Rose',
    emoji: '🌸',
    vars: {
      '--clr-p':   '#f4a5ae',
      '--clr-s':   '#e8c4d6',
      '--clr-a':   '#d4a5a5',
      '--clr-bg':  '#fffbf7',
      '--clr-t1':  '#5a4a42',
      '--clr-t2':  '#8b7b73',
    },
  },
  ocean: {
    id: 'ocean',
    name: 'Ocean',
    emoji: '🌊',
    vars: {
      '--clr-p':   '#5ba8c4',
      '--clr-s':   '#b8d8e8',
      '--clr-a':   '#7ec8e3',
      '--clr-bg':  '#f5fbff',
      '--clr-t1':  '#1a3a4a',
      '--clr-t2':  '#4a7a8a',
    },
  },
  forest: {
    id: 'forest',
    name: 'Forest',
    emoji: '🌿',
    vars: {
      '--clr-p':   '#5a9e7a',
      '--clr-s':   '#c4ddd0',
      '--clr-a':   '#7cb99a',
      '--clr-bg':  '#f5fbf7',
      '--clr-t1':  '#1a3a2a',
      '--clr-t2':  '#4a7a5a',
    },
  },
  lavender: {
    id: 'lavender',
    name: 'Lavender',
    emoji: '💜',
    vars: {
      '--clr-p':   '#9b85c4',
      '--clr-s':   '#d8cff0',
      '--clr-a':   '#b5a0d8',
      '--clr-bg':  '#faf8ff',
      '--clr-t1':  '#2a1a4a',
      '--clr-t2':  '#6a5a8a',
    },
  },
  sunset: {
    id: 'sunset',
    name: 'Sunset',
    emoji: '🌅',
    vars: {
      '--clr-p':   '#e8895a',
      '--clr-s':   '#f5c9a8',
      '--clr-a':   '#e8a878',
      '--clr-bg':  '#fff8f5',
      '--clr-t1':  '#4a2a1a',
      '--clr-t2':  '#8a5a3a',
    },
  },
  midnight: {
    id: 'midnight',
    name: 'Midnight',
    emoji: '🌙',
    vars: {
      '--clr-p':   '#8b9fd8',
      '--clr-s':   '#2e3d5e',
      '--clr-a':   '#7088c0',
      '--clr-bg':  '#12152a',
      '--clr-t1':  '#e8eaf5',
      '--clr-t2':  '#9aa0c0',
    },
  },
};

export const DEFAULT_THEME = 'rose';

export function applyTheme(themeId) {
  const theme = THEMES[themeId] || THEMES[DEFAULT_THEME];
  const root = document.documentElement;
  Object.entries(theme.vars).forEach(([k, v]) => root.style.setProperty(k, v));
  localStorage.setItem('rkindu-theme', themeId);
}

export function getStoredTheme() {
  return localStorage.getItem('rkindu-theme') || DEFAULT_THEME;
}
